<template>
    <li
      class="emd-nav-list__item"
      :class="[
        {'_active': active},
        `_color_${color}`
      ]"
    >
      <a v-if="!hasContentSlot" data-testid="list-item-anchor" :href="href" class="emd-nav-list__link"><slot /></a>
      <slot v-else name="content" />
    </li>
</template>

<script>
export default {
  name: 'emdNavListItem',
  props: {
    href: {
      type: String,
      required: false
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      validator: (value) =>
        ['primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'info'].includes(value)
    }
  },
  computed: {
    hasContentSlot () {
      return !!this.$slots.content
    }
  }
}
</script>
